var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "video-thumbnails touch"
  }, [_c('vue-slick-carousel', _vm._b({
    ref: "videoSlider",
    on: {
      "afterChange": _vm.onSliderChange
    },
    scopedSlots: _vm._u([{
      key: "customPaging",
      fn: function fn(page) {
        return [_c('div', {
          staticClass: "dot"
        }, [_vm._v("\n        " + _vm._s(page) + "\n      ")])];
      }
    }])
  }, 'vue-slick-carousel', _vm.settings, false), _vm._l(_vm.videos, function (video, index) {
    return _c('div', {
      key: video._id,
      staticClass: "video-card touch"
    }, [_vm.getType(video.asset.path) === 'video' ? [_c('div', {
      staticClass: "video-card__thumbnail"
    }, [_c('img', {
      attrs: {
        "src": _vm.$store.state.assetsPath + (video.asset.customPath ? video.asset.customPath : video.asset.thumbPath)
      }
    })]), video.label[_vm.language.code] ? _c('div', {
      staticClass: "video-card__label"
    }, [_vm._v(_vm._s(video.label[_vm.language.code]))]) : _vm._e(), _vm.status !== 'playing' || index !== _vm.activeIndex ? _c('div', {
      staticClass: "video-card__controls video-card__controls--play touch",
      on: {
        "click": function click($event) {
          return _vm.playVideo(index);
        }
      }
    }, [_c('fa', {
      attrs: {
        "icon": ['fas', 'play']
      }
    })], 1) : _vm._e(), index === _vm.activeIndex && _vm.status === 'playing' ? _c('div', {
      staticClass: "video-card__controls touch",
      on: {
        "click": _vm.stopVideo
      }
    }, [_c('fa', {
      attrs: {
        "icon": ['fas', 'stop']
      }
    })], 1) : _vm._e()] : _vm._e(), _vm.getType(video.asset.path) === 'image' ? [_c('div', {
      staticClass: "video-card__thumbnail"
    }, [_c('img', {
      attrs: {
        "src": _vm.$store.state.assetsPath + (video.asset.customPath ? video.asset.customPath : video.asset.thumbPath)
      }
    })]), video.label[_vm.language.code] ? _c('div', {
      staticClass: "video-card__label"
    }, [_vm._v(_vm._s(video.label[_vm.language.code]))]) : _vm._e(), _vm.status !== 'playing' || index !== _vm.activeIndex ? _c('div', {
      staticClass: "touch"
    }) : _vm._e(), index === _vm.activeIndex && _vm.status === 'playing' ? _c('div', {
      staticClass: "touch"
    }) : _vm._e()] : _vm._e()], 2);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }